import { Flame, ShieldCheck, TrendingUp } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const pillars = [
  { icon: Flame, title: "Infrastructure", copy: "1–6 burner cooklines, combi ovens, extraction, cold storage and prep zones — every unit built to commercial standard." },
  { icon: ShieldCheck, title: "Compliance", copy: "Trade licence, Dubai Municipality approvals, fire safety and hygiene — handled by our team, not yours." },
  { icon: TrendingUp, title: "Growth", copy: "A prime delivery catchment across Dubai South, Al Furjan, Jebel Ali Village and JBR — scale from day one." },
];

export default function Difference() {
  return (
    <section id="difference" className="py-24 md:py-32" data-testid="difference-section">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 md:grid-cols-2 md:px-8 lg:gap-20">
        <Reveal className="relative order-2 md:order-1">
          <div className="group relative overflow-hidden rounded-2xl border border-gold/25 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.8)]">
            <img
              src="/assets/gallery/combi-oven.webp"
              alt="UNOX Cheftop combi oven under extraction hood at Royal Express DIP kitchen"
              loading="lazy"
              className="h-[440px] w-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-105 md:h-[560px]"
              data-testid="difference-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" aria-hidden="true" />
            <span className="absolute bottom-5 left-5 rounded-sm border border-gold/50 bg-black/70 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.22em] text-gold backdrop-blur-md">
              UNOX Cheftop · Combi Oven
            </span>
          </div>
        </Reveal>

        <div className="relative order-1 md:order-2">
          <span className="pointer-events-none absolute -top-16 right-0 select-none font-script text-[9rem] leading-none text-gold/[0.05]" aria-hidden="true">
            Royal
          </span>
          <Reveal>
            <p className="text-[11px] font-semibold uppercase tracking-[0.34em] text-gold" data-testid="difference-eyebrow">Why Royal Express</p>
            <h2 className="mt-4 font-serif text-4xl font-medium leading-[1.08] tracking-tight text-white md:text-5xl" data-testid="difference-heading">
              The Royal Express <span className="italic text-gold">difference</span>
            </h2>
            <p className="mt-6 max-w-xl text-sm font-light leading-relaxed text-white/70 md:text-base" data-testid="difference-copy">
              We provide end-to-end cloud kitchen solutions — from premium kitchen infrastructure to operational
              support — so you can focus on what you do best: creating amazing food.
            </p>
          </Reveal>
          <div className="mt-10 space-y-8">
            {pillars.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.12}>
                <div className="group flex items-start gap-5" data-testid={`difference-pillar-${p.title.toLowerCase()}`}>
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-gold/40 bg-gold/10 text-gold transition-all duration-500 group-hover:bg-gold group-hover:text-black">
                    <p.icon size={20} strokeWidth={1.5} />
                  </span>
                  <div>
                    <h3 className="font-serif text-2xl font-medium text-white">{p.title}</h3>
                    <p className="mt-1.5 max-w-md text-sm font-light leading-relaxed text-white/60">{p.copy}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
